
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi faire appel à une agence Instagram Ads comme ALEO",
    description:
      "Découvrez pourquoi faire appel à une agence Instagram Ads comme ALEO peut transformer votre stratégie marketing. Boostez votre visibilité et maximisez votre ROI.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
